import React, { useRef, useEffect, useState, useCallback } from 'react';
import Modal from 'react-modal';
import { useSelector, useDispatch } from 'react-redux';
import QuickSearchResult from '../../Components/QuickSearchResult';
import { translate } from '../../Services/translation';
import {
  query,
  setSearchQuery,
  toggleShowFullForm,
  handleKeyDown,
  handleClickSearch,
} from '../../Actions/QuickSearch.action';
import usePrevious from '@react-hook/previous';
import { debounce } from 'lodash-es';

// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);

const QuickSearch = () => {
  const { query, result, showResult, showFullForm, selectedItem } = useSelector(
    (state) => state.quickSearch
  );

  const searchUrl =
    window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '');
  const searchInput = useRef(null);
  const dispatch = useDispatch();
  const previousSelectedItem = usePrevious(selectedItem);

  const customStyles = {
    content: {
       background: 'none',
       padding: '16px',
       border: 'none',
       inset: '0',
       position: 'relative',
       maxWidth: '700px',
       marginLeft: 'auto',
       marginRight: 'auto',
       marginTop: '100px',
       overflow: 'unset'
    },
    overlay: {
      background: 'rgba(1, 1, 1, 0.5)',
      zIndex: 2003,
    },
  };

 
  useEffect(() => {
    // set query value if it is avaialble in the Url
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('q')) {
      const query = urlParams.get('q');
      dispatch(setSearchQuery(query));
    }
  }, [dispatch]);

  useEffect(() => {
    if (selectedItem !== previousSelectedItem) {
      const el = document.querySelector('.quick-search-result__item--selected');
      el &&
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
    }
  }, [selectedItem, previousSelectedItem]);

  return (
    <div className="quick-search" role="search">
      <a
        className="quick-search__link--block"
        rel="nofollow"
        href="#"
        title={translate('general.search')}
        onClick={(e) => {
          e.preventDefault();
          dispatch(toggleShowFullForm());
          setTimeout(() => {
            searchInput.current && searchInput.current.focus();
          }, 0);
        }}
      >
        <i className="quick-search__icon"></i>
        <span className="quick-search__title hide">
          {translate('general.search')}
        </span>
      </a>
      <Modal
        ariaHideApp={false}
        preventScroll={true}
        isOpen={showFullForm}
        onRequestClose={(e) => dispatch(toggleShowFullForm())}
        style={customStyles}
        shouldCloseOnOverlayClick={true}
      >
        <div
          className={`quick-search__form ${
            showResult ? 'quick-search__form--show-result' : ''
          }`}
          role="search"
        >
          {/* <span onClick={(e) => { dispatch(toggleShowFullForm());}} className="quick-search__close"></span> */}
          <input
            className="quick-search__input"
            type="search"
            placeholder={translate('general.search')}
            autoComplete="off"
            value={decodeURIComponent(query)}
            onChange={(event) => {
              const text = encodeURIComponent(event.target.value);
              dispatch(setSearchQuery(text));
              debouncedQuery(dispatch, text);
            }}
            onKeyDown={(event) => dispatch(handleKeyDown(event, { searchUrl }))}
            ref={searchInput}
          />
          <button
            className="quick-search__submit-button"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              dispatch(handleClickSearch({ searchUrl }));
            }}
          >
            <i className="quick-search__submit-icon"></i>
            <span className="quick-search__submit-title">
              {translate('general.search')}
            </span>
          </button>
          {showResult && (
            <QuickSearchResult
              result={result}
              selectedItem={selectedItem}
              searchUrl={searchUrl}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default QuickSearch;
